import moment from 'moment';
import axios from 'axios';

const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


/** Раздел 'Гарантии' */
export default {
  name: 'guaranteeForm',
  data() {
    return {
      // Адреса
      addresses: [],
      // v-model для адреса
      searchAddress: '',
      // Процесс отправки монтажа на сохранение/проверку
      submitIsProcessing: false,
      // Правила валидации формы
      rules: {
        required: value => !!value || 'Поле должно быть заполнено',
        email: v => pattern.test(v) || 'Поле E-mail заполнено с ошибками',
      },
      // Форма добавления монтажа
      form: {
        customer_full_name: '',
        customer_email: '',
        date_issue: '',
        date_issue_local: '',
        certificate_id: null,
        address: '',
      },
      isEditable: true,
      maxDate: moment().format('YYYY-MM-DD'),
      // v-model для формы
      valid: false,
      // v-model для меню выбора даты монтажа
      dateMenu: false,
    };
  },
  computed: {
    certificates() {
      return this.$store.state.guarantees.certificates;
    },
  },
  mounted() {
    this.$store.dispatch('guarantees/GetCertificates', {
      profile_id: this.$store.state.user.profile_id,
    });
    this.$watch('form.date_issue', (val) => {
      this.form.date_issue_local = val && moment(val).format('DD.MM.YYYY');
    });
  },
  methods: {
    onSubmit(needSendToCustomer = false) {
      const app = this;
      if (app.valid) {
        const data = {
          ...this.form,
          need_send_to_customer: needSendToCustomer,
          profile_id: this.$store.state.user.profile_id,
        };
        app.$store.getters.axl.post('guarantees/api/guarantee/create', data)
          .then(() => {
            app.$refs.guaranteeForm.reset();
            app.$refs.guaranteeForm.resetValidation();
            app.$store.dispatch('ShowInfo', 'Гарантия отправлена');
            this.$emit('close', true);
          })
          .catch((error) => {
            app.$store.dispatch('HandleError', error);
          });
      }
    },
  },
  watch: {
    /** Вотчер для автокомплита адресов */
    searchAddress(query) {
      if (query) {
        const app = this;
        const info = { count: 20, query };
        const config = {
          headers: {
            Accept: 'application/json, text/javascript, */*; q=0.01',
            Authorization: 'Token 7a77efb8ab6dae6e380c7e438b85360185660f34',
            'Content-Type': 'application/json',
          },
        };

        axios
          .post('https://dadata.ru/api/v2/suggest/address', info, config)
          .then((res) => {
            app.addresses = res.data.suggestions;
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
  },
};
